import contextMenuReducer from './reducers';

export default contextMenuReducer;
